import pipe from 'lodash/fp/pipe';
import getOr from 'lodash/fp/getOr';
import toLower from 'lodash/fp/toLower';
import either from 'ramda/src/either';
import equals from 'ramda/src/equals';
import { getActiveShopCurrency, getCountryCodeByCurrency } from '../../auth/selectors';

export const getMerchantSerialNumber = getOr(null, 'settings.merchantInfo.serialNumber');
export const getTotalBalance = getOr(0, 'settings.balance.total');
export const getInstantPayoutIsFetching = getOr(false, 'settings.initiateInstantPayout.isFetching');
export const getPaymentCard = getOr(false, 'settings.paymentCard');
export const getShouldShowDebitCard = pipe(
  getActiveShopCurrency,
  toLower,
  either(equals('usd'), equals('cad'))
);
export const getSubscription = getOr(null, 'settings.subscription');
export const getSubscriptionStatus = getOr(null, 'settings.subscription.status');
export const canManageSubscription = getOr(false, 'settings.subscription.status.canManageSubscription');

export const shouldOpenNewPaymentProcessing = (state) => {
  const country = getCountryCodeByCurrency(state);
  const newPaymentProcessingInAllCountries = true;

  return (newPaymentProcessingInAllCountries || country === 'US');
};

export const shouldOpenPaymentProcessingDashboard = state =>
  shouldOpenNewPaymentProcessing(state);

export const selectManagedAccountId = getOr(null, 'settings.bankAccount.managedAccountId');
